import { useCallback, useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged, User } from "firebase/auth";
import { auth, db } from "../../Lib/Firebase";
import { openAuthModal } from "../AuthModal";
import { ExperienceType } from "./content";

export function scrollToSection(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function useLandingActions() {
    const [user, setUser] = useState<User | null>(auth.currentUser);

    useEffect(() => onAuthStateChanged(auth, setUser), []);

    const startExperience = useCallback(async (type: ExperienceType) => {
        if (!user) {
            openAuthModal("student", `/onboarding?type=${type}`);
            return;
        }
        try {
            const snapshot = await getDoc(doc(db, "users", user.uid));
            const complete = snapshot.exists() && (snapshot.data()?.bookingDone || snapshot.data()?.onboardingComplete);
            window.location.href = complete ? "/dashboard" : `/onboarding?type=${type}`;
        } catch (error) {
            console.error("Failed to get booking status", error);
            window.location.href = `/onboarding?type=${type}`;
        }
    }, [user]);

    const signIn = useCallback(() => openAuthModal("student"), []);

    return { signIn, startExperience };
}
